import React, {
  useEffect,
  useMemo,
  useState,
  useCallback,
  useRef,
} from "react";
import styles from "./CustomerTransactionNew.module.css";
import AdminHeading from "../AdminPanel/Heading/AdminHeading";
import AlertMessage from "Components/Other Functions/AlertMessage";
import { ClipLoader } from "react-spinners";
import ErrorModal from "Components/Other Functions/popup";
import {
  useNavigate,
  useParams,
  useSearchParams,
  useLocation,
} from "react-router-dom";
import { toPlainFields } from "Components/support/Allfields/fieldconverter";
import {
  InvoiceEntryNewFields,
  OldGoldInvoiceEntryNewFields,
  PurchaseEntryFields,
  PurchaseEntryNewFields,
} from "Components/support/Allfields/purchasefields";
import { useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { RiAddBoxFill } from "react-icons/ri";
import { IoMdRefresh } from "react-icons/io";
import { GoTrash } from "react-icons/go";
import { Icon } from "@iconify/react";
import Summary from "Components/AdminPurchaseEntryNew/Summary";
import SkuForm from "Components/AdminPurchaseEntryNew/SkuForm";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import GetApiService from "Components/Api/getapiService";
import {
  calculateAmount,
  convertInInvoiceWholeSaleFormat,
  getAllPaymentMethod,
  getCurrentFinancialYear,
  getInvoiceEditEntryFormData,
  getInvoiceEntryFormData,
  goldCategoryIds,
  looseDiamondId,
  looseStoneId,
  selectStyle,
  selectStylee,
  silverCategoryIds,
} from "utils/helpers";
import toast from "react-hot-toast";
import PaymentModeForm from "Components/AdminPurchaseEntryNew/PaymentModeForm";
import Select from "react-select";
import StoneSummary from "Components/AdminPurchaseEntryNew/StoneSummary";
import DiamondSummary from "Components/AdminPurchaseEntryNew/DiamondSummary";
import PaymentsEntryTable from "Components/AdminPurchaseEntryNew/PaymentsEntryTable";
import AmountSection from "Components/AdminPurchaseEntryNew/AmountSection";
import InvoiceSkuForm from "Components/AdminPurchaseEntryNew/InvoiceSkuForm";
import InvoiceWholeSaleSummary from "Components/AdminPurchaseEntryNew/InvoiceWholeSaleSummary";
import AdminBreadCrump from "../AdminPanel/Heading/AdminBreadCrump";
import { Check, Refresh } from "@mui/icons-material";
import Spinner from "Components/CommonComponents/Spinner";
import { a201, a710, a714, a717, a729, a731 } from "Components/Api/RootApiPath";
import PageLoader from "Components/PageLoader";
import { fetchInvoiceList, fetchInvoiceNumber } from "services/invoiceServices";
import { fetchCustomerTouncheList } from "services/Tounches";
import {
  generateBillInvocePDF,
  generateBillPDF,
} from "Components/Other Functions/GenerateBillPDF";
// import { useAdminData } from "../AdminSettings/useAdminData";
import { fetchAllRates } from "services/rate";

import useScreenSize from "hooks/useScreenSize";
import PaymentModule from "Components/AdminPurchaseEntryNew/PaymentModule";
import {
  getAllCustomerTransaction,
  addCustomerTransaction,
  updateCustomerBalanceAmount,
  addCustomerIssue,
} from "services/customerTransaction";
import { CustomerTransactionReport } from "Components/Other Functions/CustomerTransactionReport";
import { pdf } from "@react-pdf/renderer";
import IssueCustomerTransaction from "Components/CommonComponents/Issue/IssueCustomerTransaction";
import RateCutTab from "Components/CommonComponents/RateCutTab/RateCutTab";
import ReceiveTab from "Components/CommonComponents/ReceiveTab/ReceiveTab";

//styles
const selectStyle1 = {
  control: (base) => ({
    ...base,
    height: "32px",
    width: "100%",
    minHeight: "32px",
    zIndex: "10",
    background: "#788695",
    color: "#fff",
  }),

  placeholder: (base) => ({
    ...base,
    color: "#aaa",
    fontStyle: "italic",
    display: "none",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "blue"
      : state.isFocused
      ? "lightblue"
      : "white",
    color: state.isSelected ? "white" : "black",
    padding: "6px",
    fontSize: "12px",
    whiteSpace: "normal", // Allows text to wrap instead of truncating
    textOverflow: "unset", // Removes ellipsis
    overflow: "visible", // Ensures full visibility of text
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: "12px",
    padding: "2px 2px 2px 0px", // Decreases padding inside the input box
    whiteSpace: "normal", // Allows full text to display
    textOverflow: "unset", // Removes ellipsis
    overflow: "visible", // Ensures full visibility of text
    color: "#fff",
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "8px",
    marginTop: "5px",
    zIndex: 999,
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: "100px", // Ensures the dropdown has a scrollable height
    overflowY: "auto", // Enables scrolling for overflow
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "4px",
    svg: {
      width: "12px",
      height: "12px",
    },
  }),
  indicatorsContainer: (base) => ({
    ...base,
    padding: "0px",
  }),
};

const headers = [
  "Sr.No.",
  "Date",
  "Tx Type",
  "Tx No.",
  "Description",
  "Gr Wt",
  "S. Wt",
  "S. Pcs",
  "D. Wt",
  "D. Pcs",
  "Net Wt",
  "F + W %",
  "F + W Wt",
  "Paid Metal",
  "Invoice Amt",
  "Paid Amt",
  "URD Wt",
  "URD Amt",
];
const defaultValues = {
  invoiceDate: new Date().toISOString().split("T")[0],
  Customer: "",
  TotalFineGold: "",
  TotalFineSilver: "",
  BalanceAmount: "",
  AdvanceAmount: "",
};

const filters = [
  {
    value: "all",
    label: "All",
  },
  {
    value: "invoice",
    label: "Invoice",
  },
  {
    value: "customer_payment",
    label: "Customer Payment",
  },
  {
    value: "rate_cut",
    label: "Rate Cut",
  },
  {
    value: "sample",
    label: "Sample",
  },
  {
    value: "stone",
    label: "Stone",
  },
  {
    value: "diamond",
    label: "Diamond",
  },
  {
    value: "repair",
    label: "Repair",
  },
  {
    value: "return",
    label: "Return",
  },
  {
    value: "credit_note",
    label: "Credit Note",
  },
  {
    value: "mds",
    label: "MDS",
  },
  {
    value: "money_lending",
    label: "Money Lending",
  },
];

const receiveOptions = [
  { value: "sample", label: "Sample In" },
  { value: "return", label: "Return" },
  { value: "receive_stone", label: "Receive Stone" },
  { value: "receive_diamond", label: "Receive Diamond" },
];

const CustomerTransactionNew = () => {
  //state
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const [invoiceCreateLoading, setInvoiceCreateLoading] = useState(false);
  const [allCustomerTransactionList, setAllCustomerTransactionList] = useState(
    []
  );
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [paymentsArray, setPaymentsArray] = useState([]);
  const [paymentAmount, setPaymentAmount] = useState({
    isGst: true,
    isAdditionalTax: false,
    discount: "",
    courierCharge: "",
  });
  const [formData, setFormData] = useState({
    customerName: "",
    mobile: "",
    fineGold: "0",
    fineSilver: "0",
    advanceAmount: "0",
    balanceAmount: "0",
  });
  const [activeTab, setActiveTab] = useState("transactions");
  const [selectedFilter, setSelectedFilter] = useState("");
  const [selectedReceiveOption, setSelectedReceiveOption] = useState("sample");
  const [issueData, setIssueData] = useState([]);

  const adminLoggedIn = useSelector((state) => state.reducer1);
  const clientCode = adminLoggedIn.ClientCode;
  const apiService = new GetApiService(clientCode);

  const isSmallScreen = useScreenSize(); // Get screen size

  const queryClient = useQueryClient();

  // Add mutation for updating customer balance
  const updateBalanceMutation = useMutation({
    mutationFn: (payload) => updateCustomerBalanceAmount({ payload }),
    onSuccess: () => {
      toast.success("Customer balance updated successfully");
    },
    onError: (error) => {
      console.error("Error updating customer balance:", error);
      toast.error("Failed to update customer balance");
    },
  });

  // Add mutation for adding customer transaction
  const addTransactionMutation = useMutation({
    mutationFn: (payload) => addCustomerTransaction({ payload }),
    onSuccess: async () => {
      toast.success("Transaction added successfully");

      // Reset form and refresh data
      setPaymentsArray([]);
      setPaymentAmount({
        isGst: true,
        isAdditionalTax: false,
        discount: "",
        courierCharge: "",
      });

      // Invalidate and refetch transactions
      await queryClient.invalidateQueries([
        "allCustomerTransactions",
        clientCode,
        selectedCustomer?.Id,
      ]);

      // Invalidate and refetch customer list
      await queryClient.invalidateQueries([
        "customerTransaction/getAllcustomerList",
        clientCode,
      ]);

      // Wait for query cache to get updated
      await new Promise((resolve) => setTimeout(resolve, 100));

      const updatedCustomerList = queryClient.getQueryData([
        "customerTransaction/getAllcustomerList",
        clientCode,
      ]);

      // Reselect the same customer to update form data
      if (selectedCustomer && Array.isArray(updatedCustomerList)) {
        // setLoad
        const updatedCustomer = updatedCustomerList.find(
          (customer) => customer.Id === selectedCustomer.value
        );

        if (updatedCustomer) {
          setFormData({
            customerName: updatedCustomer.FirstName || "",
            mobile: updatedCustomer.Mobile || "",
            fineGold: updatedCustomer.FineGold || "0",
            fineSilver: updatedCustomer.FineSilver || "0",
            advanceAmount: updatedCustomer.AdvanceAmount || "0",
            balanceAmount: updatedCustomer.BalanceAmount || "0",
          });

          setValue("TotalFineGold", updatedCustomer.FineGold);
          setValue("TotalFineSilver", updatedCustomer.FineSilver);
          setValue("AdvanceAmount", updatedCustomer.AdvanceAmount);
          setValue("BalanceAmount", updatedCustomer.BalanceAmount);

          // Force a re-render of the customer selection
          const customerOption = {
            value: updatedCustomer.Id,
            label: updatedCustomer.FirstName,
            ...updatedCustomer,
          };
          setSelectedCustomer(customerOption);
        }
      }
    },
    onError: (error) => {
      console.error("Error adding transaction:", error);
      toast.error("Failed to add transaction");
    },
  });

  // Query for customer transactions
  const {
    data: TransactionList,
    isLoading: isTransactionsLoading,
    isError: isTransactionsError,
    error: transactionsError,
    refetch: refetchTransactions,
  } = useQuery({
    queryKey: ["allCustomerTransactions", clientCode, selectedCustomer?.Id],
    queryFn: () =>
      getAllCustomerTransaction({
        payload: { clientCode, clientCode, CustomerId: selectedCustomer?.Id },
      }),
    enabled: !!clientCode && !!selectedCustomer?.Id,
    refetchOnWindowFocus: false,
  });

  //query for update customer balance amount
  const updateCustomerBalance = useQuery({
    queryKey: ["updateCustomerBalance", paymentAmount.balanceAmount],
    queryFn: () => updateCustomerBalanceAmount(payload),
  });

  useEffect(() => {
    if (TransactionList) {
      setAllCustomerTransactionList(TransactionList);
    } else {
      setAllCustomerTransactionList([]);
    }
  }, [TransactionList]);

  const fetchData = async () => {
    try {
      const data = await apiService.fetchInvoiceCustomers();
      return data;
    } catch (e) {
      console.error(e);
    }
  };

  const {
    data: customerList,
    isLoading,
    isError,
    refetch: RefetchCustomerList,
  } = useQuery({
    queryKey: ["customerTransaction/getAllcustomerList", clientCode],
    queryFn: fetchData,
    refetchOnWindowFocus: false,
    staleTime: 2 * 60 * 1000, // Data stays fresh for 2 minutes
    cacheTime: 15 * 60 * 1000, // Cache data for 15 minutes
  });

  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: defaultValues,
  });
  const customer = watch("Customer");

  useEffect(() => {
    const customerr = customerList?.length
      ? customerList?.find((customr) => customr?.Id == customer?.value)
      : {};
    if (customerr?.Id) {
      setValue("TotalFineGold", customerr?.FineGold);
      setValue("TotalFineSilver", customerr?.FineSilver);
      setValue("AdvanceAmount", customerr?.AdvanceAmount);
      setValue("BalanceAmount", customerr?.BalanceAmount);
    } else {
      setValue("TotalFineGold", customerr?.FineGold);
      setValue("TotalFineSilver", customerr?.Mobile);
      setValue("AdvanceAmount", customerr?.AdvanceAmount);
      setValue("BalanceAmount", customerr?.BalanceAmount);
    }
  }, [customer?.value, customerList]);

  const handleCustomerNameChange = (option) => {
    setSelectedCustomer(option);
    setValue("Customer", option);

    if (option) {
      const selectedCustomerData = customerList?.find(
        (customer) => customer.Id === option.value
      );
      if (selectedCustomerData) {
        setFormData({
          customerName: selectedCustomerData.FirstName || "",
          mobile: selectedCustomerData.Mobile || "",
          fineGold: selectedCustomerData.FineGold || "0",
          fineSilver: selectedCustomerData.FineSilver || "0",
          advanceAmount: selectedCustomerData.AdvanceAmount || "0",
          balanceAmount: selectedCustomerData.BalanceAmount || "0",
        });
      }
    } else {
      // Reset form data if no customer is selected
      setFormData({
        customerName: "",
        mobile: "",
        fineGold: "0",
        fineSilver: "0",
        advanceAmount: "0",
        balanceAmount: "0",
      });
    }
  };

  const printCustomerTransactionReport = async () => {
    if (!selectedCustomer || !allCustomerTransactionList) return;

    const selectedCustomerData = customerList?.find(
      (customer) => customer.Id === selectedCustomer.value
    );

    // Process transactions to separate receipt/credit and issue/debit
    const processedTransactions = allCustomerTransactionList.map(
      (transaction) => {
        const isPaid = transaction.TransactionType === "paid";
        return {
          date: transaction.Date || "-",
          receipt: {
            description: isPaid ? transaction.Description : "",
            GrWt: isPaid ? transaction.GrossWt : "0",
            netWt: isPaid ? transaction.NetWt : "0",
            finePercent: isPaid ? transaction.FinePercentage : "0",
            wastagePercent: isPaid ? transaction.WastagePercentage : "0",
            fine: isPaid ? transaction.FineWastageWt : "0",
            amount: isPaid ? transaction.InvoiceAmount : "0",
          },
          issue: {
            description: !isPaid ? transaction.Description : "",
            GrWt: !isPaid ? transaction.GrossWt : "0",
            netWt: !isPaid ? transaction.NetWt : "0",
            finePercent: !isPaid ? transaction.FinePercentage : "0",
            wastagePercent: !isPaid ? transaction.WastagePercentage : "0",
            fine: !isPaid ? transaction.FineWastageWt : "0",
            amount: !isPaid ? transaction.InvoiceAmount : "0",
          },
        };
      }
    );

    // Get totals from the API response
    const totals = {
      receipt: {
        GrWt: TransactionList?.totalReceiptGrWt || "0",
        netWt: TransactionList?.totalReceiptNetWt || "0",
        finePercent: TransactionList?.totalReceiptFinePercent || "0",
        wastagePercent: TransactionList?.totalReceiptWastagePercent || "0",
        fine: TransactionList?.totalReceiptFine || "0",
        amount: TransactionList?.totalReceiptAmount || "0",
      },
      issue: {
        GrWt: TransactionList?.totalIssueGrWt || "0",
        netWt: TransactionList?.totalIssueNetWt || "0",
        finePercent: TransactionList?.totalIssueFinePercent || "0",
        wastagePercent: TransactionList?.totalIssueWastagePercent || "0",
        fine: TransactionList?.totalIssueFine || "0",
        amount: TransactionList?.totalIssueAmount || "0",
      },
    };

    const reportData = {
      customer: selectedCustomerData?.FirstName || "",
      city: selectedCustomerData?.City || "",
      contact: selectedCustomerData?.Mobile || "",
      date: new Date().toLocaleDateString(),
      totalCash: selectedCustomerData?.BalanceAmount || "0",
      totalGoldBalance: selectedCustomerData?.FineGold || "0",
      totalSilverBalance: selectedCustomerData?.FineSilver || "0",
      advanceAmount: selectedCustomerData?.AdvanceAmount || "0",
      items: processedTransactions,
      totals: totals,
    };

    try {
      const blob = await pdf(
        <CustomerTransactionReport data={reportData} />
      ).toBlob();
      const url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");
    } catch (error) {
      console.error("Error generating PDF:", error);
      toast.error("Failed to generate PDF. Please try again.");
    }
  };

  const handleSaveTransaction = async () => {
    try {
      // Prepare payment modes array
      const paymentModes = paymentsArray.map((payment, index) => ({
        // Id: 0,
        // CreatedOn: new Date().toISOString(),
        // LastUpdated: new Date().toISOString(),
        StatusType: true,
        CustomerId: selectedCustomer.Id,
        // CustomerTransactionId: 0,
        PaymentModeType: payment.paymentMode,
        // PaymentSource: "Customer",
        // CreditDebit: payment.paymentType,
        Amount: payment.paymentAmount,
        TransactionType: payment.paymentType,
        // InvoiceNumber: "",
        // BillType: "CustomerTransaction",
        // PaymentVisibility: "Visible",
        // FinancialYear: new Date().getFullYear().toString(),
        // Branch: "",
        FineGold: paymentAmount.fineMetal,
        FineSilver: formData.fineSilver,
        // FineOtherMetal: "0",
        // SilverRate: "0",
        // GoldRate: "0",
        // OtherMetalRate: "0",
        // GoldAmount: "0",
        // SilverAmount: "0",
        // OtherMetalAmount: "0",
        // OldGoldGrossWt: "0",
        // OldSilverGrossWt: "0",
        // OtherMetalGrossWt: "0",
        // GoldPurity: "0",
        // SilverPurity: "0",
        // OtherMetalPurity: "0",
        // VendorId: 0,
        // InvoiceId: 0,
        // InwardNo: "",
        // OrderId: 0,
        CustomerName: formData.customerName,
        // VendorName: "",
        // RDPurchaseId: 0,
        // Status: "Active",
        Description: payment.paymentDescription || "",
        // BranchId: 0,
        // CounterId: 0,
        // EmployeeId: 0,
        // CompanyId: 0,
        ClientCode: clientCode,
        // BankId: 0,
        // CardPercentage: "0",
        // ChequeBankName: "",
        // ChequeBankAccountNo: "",
        // ChequeNo: "",
        // ChequePayeeName: "",
        // ChequeClearStatus: "",
        // CardBankName: "",
        // CardNo: "",
        // CardPayeeName: "",
        // RtgsBankName: "",
        // RtgsAccountName: "",
        // RtgsAccountNo: "",
        // MetalType: "",
        // RtgsReferenceNo: "",
        // CustomOrderId: 0,
        // TransactionDate: ""
      }));

      // Prepare the main payload
      const payload = {
        // CustomerTransactionId: 0,
        CustomerId: selectedCustomer.Id,
        Amount: paymentAmount.paidAmount || "0",
        // TransactionType: "CustomerTransaction",
        // Description: paymentAmount.paymentDescription || "",
        ClientCode: clientCode,
        BalanceSilver: formData.fineSilver,
        BalanceGold: paymentAmount.balanceMetal,
        BalanceAmt: "-" + paymentAmount.paidAmount,
        PaymentModes: paymentModes,
      };

      // Check if balance amount has changed
      if (formData.balanceAmount !== paymentAmount.balanceAmount) {
        // Prepare payload for balance amount update
        const balanceUpdatePayload = {
          ...selectedCustomer,
          BalanceAmount: paymentAmount.balanceAmount,
        };

        // Update customer balance amount using mutation
        await updateBalanceMutation.mutateAsync(balanceUpdatePayload);
      }

      // Add the transaction
      await addTransactionMutation.mutateAsync(payload);
      toast.success("Transaction saved successfully");
    } catch (error) {
      console.error("Error saving transaction:", error);
      toast.error("Failed to save transaction");
    }
  };

  const handleSaveIssue = async () => {
    if (!issueData.length) {
      toast.error("Please add items to issue");
      return;
    }

    try {
      const issuePayload = issueData.map((item) => ({
        CustomerId: item.CustomerId,
        ItemCode: item.ItemCode,
        GrossWt: item.GrossWt,
        NetWt: item.NetWt,
        CategoryId: item.CategoryId || 0,
        ProductId: item.ProductId || 0,
        DesignId: item.DesignId || 0,
        PurityId: item.PurityId || 0,
        Quantity: item.Qty || 0,
        MetalRate: item.MetalRate || "0",
        LotNumber: item.LotNumber || "",
        TotalWt: item.TotalWeight,
        PackingWeight: item.PackingWeight || "0",
        FineWastagePercent: item.FinePercent,
        FineWastageWt: item.FineWastageWt,
        StoneWeight: item.TotalStoneWeight,
        DiamondWeight: item.DiamondWeight,
        SampleStatus: "SampleOut",
        ClientCode: clientCode,
      }));

      let issuePayload1 = issuePayload[0];

      await addCustomerIssue({ payload: issuePayload1 });
      toast.success("Issue data saved successfully");
      setIssueData([]);
    } catch (error) {
      console.error("Error saving issue data:", error);
      toast.error("Failed to save issue data");
    }
  };

  const handleSaveReceive = async () => {
    if (!selectedReceiveOption) {
      toast.error("Please select a receive option");
      return;
    }
    toast.success("Receive data saved successfully");
  };

  const handleSaveRateCut = async () => {
    toast.success("Rate cut saved successfully");
  };

  const handleTransactionSubmit = async () => {
    if (!selectedCustomer) {
      toast.error("Please select a customer first");
      return;
    }

    setInvoiceCreateLoading(true);
    try {
      switch (activeTab) {
        case "transactions":
          await handleSaveTransaction();
          break;
        case "issue":
          await handleSaveIssue();
          break;
        case "receive":
          await handleSaveReceive();
          break;
        case "ratecut":
          await handleSaveRateCut();
          break;
        default:
          toast.error("Invalid tab selected");
      }
    } catch (error) {
      console.error("Error in transaction submission:", error);
      toast.error("Failed to save data");
    } finally {
      setInvoiceCreateLoading(false);
    }
  };

  // Memoize the payment handlers
  const handleSetPaymentsArray = useCallback((newPayments) => {
    setPaymentsArray(newPayments);
  }, []);

  const handleSetPaymentAmount = useCallback((newAmount) => {
    setPaymentAmount(newAmount);
  }, []);

  // Memoize the paymentsArray prop
  const memoizedPaymentsArray = useMemo(() => {
    return paymentsArray?.length ? paymentsArray : [];
  }, [paymentsArray]);

  // useEffect(() => {
  //   // Set active tab from URL query parameter if present
  //   const tabParam = searchParams.get('tab');
  //   if (tabParam) {
  //     setActiveTab(tabParam);
  //   }
  // }, [searchParams]);

  useEffect(() => {
    // Only proceed if we have the specific flag for customer selection
    if (
      location.state?.shouldSelectCustomer &&
      location.state?.productData &&
      customerList
    ) {
      setActiveTab("payments");
      const productData = location.state.productData;

      // Find the customer in customerList
      if (productData?.Customer?.Id) {
        const selectedCustomerData = customerList.find(
          (customer) => customer.Id === productData.Customer.Id
        );

        if (selectedCustomerData) {
          // Create the customer option for the dropdown
          const customerOption = {
            value: selectedCustomerData.Id,
            label: selectedCustomerData.FirstName,
            ...selectedCustomerData,
          };

          // Set the selected customer in the dropdown
          setSelectedCustomer(customerOption);
          setValue("Customer", customerOption);

          // Update form data
          setFormData({
            customerName: selectedCustomerData.FirstName || "",
            mobile: selectedCustomerData.Mobile || "",
            fineGold: selectedCustomerData.FineGold || "0",
            fineSilver: selectedCustomerData.FineSilver || "0",
            advanceAmount: selectedCustomerData.AdvanceAmount || "0",
            balanceAmount: selectedCustomerData.BalanceAmount || "0",
          });

          // Set form values
          setValue("TotalFineGold", selectedCustomerData.FineGold);
          setValue("TotalFineSilver", selectedCustomerData.FineSilver);
          setValue("AdvanceAmount", selectedCustomerData.AdvanceAmount);
          setValue("BalanceAmount", selectedCustomerData.BalanceAmount);
        }
      }

      // Clear the location state after using it
      window.history.replaceState({}, document.title);
    }
  }, [location.state, customerList, setValue]);

  return (
    <>
      <div>
        <AdminHeading />
        {/* {invoiceCreateLoading ? (
          // Show spinner while loading
          <div className="spinner-container">
            <PageLoader />
          </div>
        ) : ( */}
        <>
          <div>
            <ErrorModal
              isOpen={false}
              onRequestClose={() => {
                setShowModal(false); // Close the modal
                navigate("/adminhome"); // Redirect to /adminhome
              }}
              onReload={() => {}}
              message={""}
            />

            <div className="adminMainBodyBox">
              {false ? (
                <AlertMessage message={messageToShow} type={messageType} />
              ) : null}
            </div>
          </div>
        </>
        {/* )} */}

        {isSmallScreen ? (
          ""
        ) : (
          <AdminBreadCrump
            title={"Customer Transaction"}
            companyName={"Loyalstring"}
            module={"Transactions"}
            page={"Customer Transaction"}
          />
        )}
      </div>

      <form className={styles.mainbox}>
        {/*basic detail section */}
        <div className={styles.linesection} style={{ padding: "0px 20px" }}>
          <div className={styles.infoline}>
            <div
              className={styles.box}
              style={{ display: "flex", alignItems: "center", gap: "6px" }}
            >
              <label>Transaction No: </label>

              {/*  */}
            </div>

            <div className={styles.dateSection}>
              <div
                style={{
                  display: "flex",
                  alignItems: "start",
                  gap: "10px",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <label htmlFor="invoiceDate">Date</label>
                <div style={{ position: "relative", display: "inline-block" }}>
                  <input
                    id="invoiceDate"
                    type="date"
                    {...register("invoiceDate")}
                    style={{
                      width: "100%",
                      padding: "5px 10px",
                      paddingRight: "30px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                      appearance: "none",
                      WebkitAppearance: "none",
                      MozAppearance: "none",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* top section */}
        <div className={styles.linesection}>
          <div className={styles.container}>
            {/* Customer Name */}
            <div className={styles.box}>
              <label>
                Customer Name <span style={{ color: "red" }}>*</span>
              </label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "2px",
                }}
              >
                <div style={{ flex: "6" }}>
                  <Select
                    options={useMemo(
                      () =>
                        customerList?.map((customer) => ({
                          value: customer.Id,
                          label: customer.FirstName,
                          ...customer, // Spread other customer properties for reference
                        })) || [],
                      [customerList]
                    )}
                    onChange={handleCustomerNameChange}
                    value={selectedCustomer}
                    placeholder="Select Customer"
                    menuPortalTarget={document.body}
                    styles={{
                      control: (base) => ({
                        ...base,

                        menu: (base) => ({
                          ...base,
                          zIndex: 9999, // 👈 ensure this is higher than the modal's z-index
                        }),
                      }),
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999, // 👈 ensure it's above the modal
                      }),
                    }}
                  />
                </div>
                <button
                  title="Add Customer"
                  type="button"
                  onClick={() => navigate("/add_customer_new")}
                  style={{ background: "#627282", flex: "1", height: "35px" }}
                >
                  +
                </button>
              </div>
            </div>

            <div className={styles.middleContainer}>
              <div className={styles.box}>
                <label>Fine Gold</label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "2px",
                  }}
                >
                  <div style={{ flex: "6" }}>
                    <input
                      type="text"
                      name="fineGold"
                      placeholder="Fine Gold"
                      value={formData.fineGold || "0"}
                      disabled
                      style={{
                        border: "1px solid #ddd",
                        height: "38px",
                        width: "100%",
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className={styles.box}>
                <label>Fine Silver</label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "2px",
                  }}
                >
                  <div style={{ flex: "6" }}>
                    <input
                      type="text"
                      name="fineSilver"
                      placeholder="Fine Silver"
                      value={formData.fineSilver || "0"}
                      disabled
                      style={{
                        border: "1px solid #ddd",
                        height: "38px",
                        width: "100%",
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className={styles.box}>
                <label>Balance Amount</label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "2px",
                  }}
                >
                  <div style={{ flex: "6" }}>
                    <input
                      type="text"
                      name="advanceAmount"
                      placeholder="Balance Amount"
                      value={formData.balanceAmount || "0"}
                      disabled
                      style={{
                        border: "1px solid #ddd",
                        height: "38px",
                        width: "100%",
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className={styles.box}>
                <label>Advance Amount</label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "2px",
                  }}
                >
                  <div style={{ flex: "6" }}>
                    <input
                      type="text"
                      name="balanceAmount"
                      placeholder="Advance Amount"
                      value={formData.advanceAmount || "0"}
                      disabled
                      style={{
                        border: "1px solid #ddd",
                        height: "38px",
                        width: "100%",
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className={styles.box}>
                <label name="StonePcs">Stone Pcs</label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "2px",
                  }}
                >
                  <div style={{ flex: "6" }}>
                    <input
                      type="text"
                      name="StonePcs"
                      placeholder="Stone Pcs"
                      value={formData.StonePcs || "0"}
                      disabled
                      style={{
                        border: "1px solid #ddd",
                        height: "38px",
                        width: "100%",
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className={styles.box}>
                <label name="StoneWt">Stone Wt</label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "2px",
                  }}
                >
                  <div style={{ flex: "6" }}>
                    <input
                      type="text"
                      name="StoneWt"
                      placeholder="Stone Wt"
                      value={formData.StoneWt || "0"}
                      disabled
                      style={{
                        border: "1px solid #ddd",
                        height: "38px",
                        width: "100%",
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className={styles.box}>
                <label name="DiamondPcs">Diamond Pcs</label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "2px",
                  }}
                >
                  <div style={{ flex: "6" }}>
                    <input
                      type="text"
                      name="Diamond Pcs"
                      value={formData.DiamondPcs || "0"}
                      disabled
                      style={{
                        border: "1px solid #ddd",
                        height: "38px",
                        width: "100%",
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className={styles.box}>
                <label name="Diamond Wt">Diamond Wt</label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "2px",
                  }}
                >
                  <div style={{ flex: "6" }}>
                    <input
                      type="text"
                      name="Diamond Wt"
                      value={formData.DiamondWt || "0"}
                      disabled
                      style={{
                        border: "1px solid #ddd",
                        height: "38px",
                        width: "100%",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* tabs */}
        <div className={styles.tabsContainerMain}>
          <div className={styles.tabsContainer}>
            <div className={styles.tabs} style={{ background: "#788695" }}>
              <div className={styles.internalTabs}>
                <button
                  type="button"
                  className={`${styles.tab} ${
                    activeTab === "transactions" ? styles.activeTab : ""
                  }`}
                  onClick={() => setActiveTab("transactions")}
                >
                  Transactions
                </button>
                <button
                  type="button"
                  className={`${styles.tab} ${
                    activeTab === "payments" ? styles.activeTab : ""
                  }`}
                  onClick={() => setActiveTab("payments")}
                >
                  Payments
                </button>
                <button
                  type="button"
                  className={`${styles.tab} ${
                    activeTab === "issue" ? styles.activeTab : ""
                  }`}
                  onClick={() => setActiveTab("issue")}
                >
                  Issue
                </button>
                <button
                  type="button"
                  className={`${styles.tab} ${
                    activeTab === "receive" ? styles.activeTab : ""
                  }`}
                  onClick={() => setActiveTab("receive")}
                >
                  Receive
                </button>
                <button
                  type="button"
                  className={`${styles.tab} ${
                    activeTab === "ratecut" ? styles.activeTab : ""
                  }`}
                  onClick={() => setActiveTab("ratecut")}
                >
                  Rate Cut
                </button>
              </div>

              {/* transaction filter */}
              {activeTab === "transactions" && (
                <div
                  className={styles.transactionFilter}
                  style={{ width: "40%" }}
                >
                  <div style={{ width: "35%" }}>
                    <Select
                      name="transactionFilter"
                      onChange={(e) => setSelectedFilter(e.target.value)}
                      className={styles.transactionFilterSelect}
                      styles={selectStyle1}
                      placeholder="Select Customer"
                      style={{ width: "30%" }}
                      options={filters}
                      defaultValue={filters[0]}
                    ></Select>
                  </div>
                  {/* <div> */}
                  {/* <input
                      type="search"
                      name="search"
                      placeholder="Search..."
                      disabled
                      className={styles.transactionSearch}
                    /> */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <input
                      type="text"
                      // value={searchInput}
                      // onChange={(e) => setSearchInput(e.target.value)}
                      placeholder="Search..."
                      style={{
                        border: "1px solid #ccc",
                        borderRadius: "0px",
                        borderBottomLeftRadius: "8px",
                        borderTopLeftRadius: "8px",
                        height: "100%",
                        backgroundColor: "#f1f5f9",
                        padding: "8px",
                        color: "white",
                      }}
                      // className={style["serach-input"]}
                      className={styles.transactionSearch}
                    />

                    <Icon
                      style={{
                        fontSize: "20px",
                        padding: "7px",
                        background: "white",
                        color: "black",
                        height: "20px",
                        width: "20px",
                        borderBottomRightRadius: "8px",
                        borderTopRightRadius: "8px",
                      }}
                      icon="mdi:magnify"
                    />
                    {/* </div> */}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* middle table */}
        <div className={styles.tabContent}>
          {activeTab === "transactions" && (
            <div className={styles.tableContainer}>
              <table className={styles.table}>
                <thead>
                  <tr>
                    {headers?.map((header, index) => (
                      <th key={index}>{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {isTransactionsLoading ? (
                    <tr>
                      <td
                        colSpan="18"
                        style={{
                          padding: "20px",
                          textAlign: "center",
                          verticalAlign: "middle",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <Spinner />
                          <span>Loading transactions...</span>
                        </div>
                      </td>
                    </tr>
                  ) : allCustomerTransactionList &&
                    allCustomerTransactionList.length > 0 ? (
                    allCustomerTransactionList.map((transaction, index) => (
                      <tr key={transaction.InvoiceId || index}>
                        <td>{index + 1}</td>
                        <td>{transaction.Date || "-"}</td>
                        <td>{transaction.TransactionType || "-"}</td>
                        <td>{transaction.TransactionNo || "0"}</td>
                        <td>{transaction.Description || "0"}</td>
                        <td>{transaction.GrossWt || "-"}</td>
                        <td>{transaction.StoneWt || "-"}</td>
                        <td>{transaction.StonePcs || "0"}</td>
                        <td>{transaction.DiamondWt || "0"}</td>
                        <td>{transaction.DiamondPcs || "0"}</td>
                        <td>{transaction.NetWt || "0"}</td>
                        <td>{transaction.WastagePercentage || "0"}</td>
                        <td>{transaction.FineWastageWt || "0"}</td>
                        <td>{transaction.URDWeight || "-"}</td>
                        <td>{transaction.URDAmount || "-"}</td>
                        <td>{transaction.URDAmount || "-"}</td>
                        <td>{transaction.URDAmount || "-"}</td>
                        <td>{transaction.URDAmount || "-"}</td>
                        <td>{transaction.URDAmount || "-"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="18"> No Data Available</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
          {activeTab === "payments" && (
            <div className={styles.linesection}>
              <PaymentModule
                setPaymentsArray={handleSetPaymentsArray}
                paymentsArray={memoizedPaymentsArray}
                setPaymentAmount={handleSetPaymentAmount}
                paymentAmount={paymentAmount}
                taxAmount={0}
                fineMetal={0}
                formData={formData}
              />
            </div>
          )}

          {activeTab === "issue" && (
            <div className={styles.tabContent} style={{ padding: "0px 20px" }}>
              <IssueCustomerTransaction
                selectedCustomer={selectedCustomer}
                onIssueDataChange={setIssueData}
              />
            </div>
          )}

          {activeTab === "receive" && (
            <>
              <div
                className={styles.receiveSubTabs}
                style={{
                  background: "#e0e0e0e0",
                }}
              >
                {receiveOptions.map((option) => (
                  <button
                    type="button"
                    key={option.value}
                    className={`${styles.receiveSubTab} ${
                      selectedReceiveOption === option.value
                        ? styles.activeSubTab
                        : ""
                    }`}
                    onClick={() => setSelectedReceiveOption(option.value)}
                    style={{
                      background: "#e0e0e0e0",
                    }}
                  >
                    {option.label}
                  </button>
                ))}
              </div>

              <div className={styles.tabContent}>
                {selectedReceiveOption === "sample" && (
                  <div
                    className={styles.tabPlaceholder}
                    style={{ padding: "0px 20px" }}
                  >
                    <ReceiveTab
                      selectedCustomer={selectedCustomer}
                      selectedOption="sample"
                    />
                  </div>
                )}

                {selectedReceiveOption === "return" && (
                  <div
                    className={styles.tabPlaceholder}
                    style={{ padding: "0px 20px" }}
                  >
                    <ReceiveTab
                      selectedCustomer={selectedCustomer}
                      selectedOption="return"
                    />
                  </div>
                )}

                {selectedReceiveOption === "receive_stone" && (
                  <div
                    className={styles.tabPlaceholder}
                    style={{ padding: "0px 20px" }}
                  >
                    <ReceiveTab
                      selectedCustomer={selectedCustomer}
                      selectedOption="receive_stone"
                    />
                  </div>
                )}

                {selectedReceiveOption === "receive_diamond" && (
                  <div
                    className={styles.tabPlaceholder}
                    style={{ padding: "0px 20px" }}
                  >
                    <ReceiveTab
                      selectedCustomer={selectedCustomer}
                      selectedOption="receive_diamond"
                    />
                  </div>
                )}
              </div>
            </>
          )}

          {activeTab === "ratecut" && (
            <div
              className={styles.tabPlaceholder}
              style={{ padding: "0px 20px" }}
            >
              <RateCutTab selectedCustomer={selectedCustomer} />
            </div>
          )}
        </div>

        {/* bottom section */}
        {activeTab !== "transactions" && (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "99.5%",
              gap: "10px",
              padding: "20px 0px",
            }}
          >
            <button
              style={{
                fontSize: "12px",
                backgroundColor: "#0077d4",
                padding: "4px 6px",
                display: "flex",
                alignItems: "center",
                gap: "5px",
                flex: "1 1 auto",
                minWidth: "100px",
                maxWidth: "150px",
              }}
              type="button"
              onClick={handleTransactionSubmit}
              disabled={!selectedCustomer || invoiceCreateLoading}
            >
              {invoiceCreateLoading ? <Spinner /> : <Check size={20} />}
              Save
            </button>
            <button
              type="button"
              onClick={printCustomerTransactionReport}
              className={styles.printButton}
              disabled={!selectedCustomer}
            >
              <Icon style={{ fontSize: "24px " }} icon="ic:outline-print" />
              Print
            </button>

            <button
              type="button"
              // onClick={handleReset}
              style={{
                background: "#fff",
                fontSize: "12px", // Smaller font size for responsiveness
                color: "#0077D4",
                padding: "4px 6px", // Adjusted padding
                display: "flex",
                alignItems: "center",
                gap: "5px",
                border: "1px solid #0077D4",
                flex: "1 1 auto",
                minWidth: "100px",
                maxWidth: "150px",
              }}
              // disabled={invoiceCreateLoading}
            >
              <Refresh size={20} /> {/* Adjusted icon size */}
              Reset
            </button>

            <button
              onClick={() => {
                navigate(`/customer_transaction_list_new`);
              }}
              type="button"
              style={{
                fontSize: "12px", // Smaller font size for responsiveness
                backgroundColor: "#0077d4",
                padding: "4px 6px", // Adjusted padding
                display: "flex",
                alignItems: "center",
                gap: "5px",
                flex: "1 1 auto",
                minWidth: "100px",
                maxWidth: "150px",
              }}
              // disabled={invoiceCreateLoading}
            >
              <Icon style={{ fontSize: "20px" }} icon="solar:list-bold" />{" "}
              {/* Adjusted icon size */}
              {/* Customer Tx List */}
              {activeTab === "issue"
                ? "Issue Tx List"
                : activeTab === "receive"
                ? "Receive Tx List"
                : "Customer Tx List"}
            </button>
          </div>
        )}
        {activeTab === "transactions" && (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "99.5%",
              gap: "10px",
              padding: "20px 0px",
            }}
          >
            <button
              type="button"
              onClick={printCustomerTransactionReport}
              className={styles.printButton}
              disabled={!selectedCustomer}
            >
              <Icon style={{ fontSize: "24px " }} icon="ic:outline-print" />
              Print
            </button>
            <button
              style={{
                fontSize: "12px",
                backgroundColor: "#0077d4",
                padding: "4px 6px",
                display: "flex",
                alignItems: "center",
                gap: "5px",
                flex: "1 1 auto",
                minWidth: "100px",
                maxWidth: "150px",
              }}
              type="button"
              onClick={handleTransactionSubmit}
              disabled={!selectedCustomer || invoiceCreateLoading}
            >
              {invoiceCreateLoading ? <Spinner /> : <Check size={20} />}
              Save
            </button>

            <button
              type="button"
              // onClick={handleReset}
              style={{
                background: "#fff",
                fontSize: "12px", // Smaller font size for responsiveness
                color: "#0077D4",
                padding: "4px 6px", // Adjusted padding
                display: "flex",
                alignItems: "center",
                gap: "5px",
                border: "1px solid #0077D4",
                flex: "1 1 auto",
                minWidth: "100px",
                maxWidth: "150px",
              }}
              // disabled={invoiceCreateLoading}
            >
              <Refresh size={20} /> {/* Adjusted icon size */}
              Reset
            </button>

            <button
              onClick={() => {
                navigate(`/customer_transaction_list_new`);
              }}
              type="button"
              style={{
                fontSize: "12px", // Smaller font size for responsiveness
                backgroundColor: "#0077d4",
                padding: "4px 6px", // Adjusted padding
                display: "flex",
                alignItems: "center",
                gap: "5px",
                flex: "1 1 auto",
                minWidth: "100px",
                maxWidth: "150px",
              }}
              // disabled={invoiceCreateLoading}
            >
              <Icon style={{ fontSize: "20px" }} icon="solar:list-bold" />{" "}
              {/* Adjusted icon size */}
              {/* Customer Tx List */}
              {activeTab === "issue"
                ? "Issue Tx List"
                : activeTab === "receive"
                ? "Receive Tx List"
                : "Customer Tx List"}
            </button>
          </div>
        )}
      </form>
    </>
  );
};

export default CustomerTransactionNew;
